import * as React from 'react';
import { AnyCnameRecord } from 'dns';

export interface GenericDropDownProps {
    trigger: any;
    style?: React.CSSProperties;
    action?: 'over' | 'click';
    closeOnOutside?: boolean;
    arrow?: boolean;
    className?: string;
}

export interface GenericDropDownState {
    open: boolean;
}

export default class GenericDropDown extends React.Component<GenericDropDownProps, GenericDropDownState> {
  constructor(props: GenericDropDownProps) {
    super(props);

    this.state = {
        open: false
    }
  }

  public componentDidMount(){
    document.addEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside.bind(this));
  }
  setWrapperRef = (node) => {
    this.wrapperRef = node;
  }

  wrapperRef: any;

 handleClickOutside = (event) => {
      if (this.wrapperRef != undefined){
        if(event
          && !this.wrapperRef.contains(event.target) 
          && this.props.closeOnOutside && this.state.open) {
        this.toggleContent();
      }
    }
  }
  public toggleContent = () =>{
    this.setState({open: !this.state.open})
  }

  public render() {

    const initial = this.props.trigger.children? this.props.trigger.children:[];

    return (
              <div style={this.props.style} className={this.props.className} onClick={this.toggleContent}>
                {this.props.trigger}
                <div ref={e => this.wrapperRef = e} className='generic-dropdown'>
                  <div className={'dropdown-content ' + (this.state.open?'show':'hidden')}>

                      {this.props.arrow && <div className="arrow-up"></div>}
                      {this.props.children}
                  </div>
                </div>
              </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/generic-dropdown.tsx